import { render, staticRenderFns } from "./HowItWorksStep.vue?vue&type=template&id=b8e8e582&scoped=true"
import script from "./HowItWorksStep.vue?vue&type=script&lang=js"
export * from "./HowItWorksStep.vue?vue&type=script&lang=js"
import style0 from "./HowItWorksStep.vue?vue&type=style&index=0&id=b8e8e582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e8e582",
  null
  
)

export default component.exports